import axios from 'axios';

const getMailboxInfo = async (domain: string) => {
  const response = await axios.get(
    `/api/services/hebergement/${domain}/mailbox`
  );
  return response.data;
};

const createMailboxAccount = async (domain: string, accountData: {
  account: string;
  password: string;
  name: string;
  quota: number;
}) => {
  const response = await axios.post(
    `/api/services/hebergement/${domain}/mailbox`,
    accountData
  );
  return response.data;
};

const createAlias = async (domain: string, aliasData: {
  alias: string;
  account: string;
}) => {
  const response = await axios.post(
    `/api/services/hebergement/${domain}/mailbox/aliases`,
    aliasData
  );
  return response.data;
};

const deleteAlias = async (domain: string,accountForAlias: number, alias: string) => {
  const response = await axios.delete(
    `/api/services/hebergement/${domain}/mailbox/aliases/${encodeURIComponent(accountForAlias)}/${encodeURIComponent(alias)}`
  );
  return response.data;
};

const getMailboxAccount = async (domain: string, mailboxId: number) => {
  const response = await axios.get(
    `/api/services/hebergement/${domain}/mailbox/${mailboxId}`
  );
  return response.data;
};

const deleteMailboxAccount = async (domain: string, mailboxId: number) => {
  const response = await axios.delete(
    `/api/services/hebergement/${domain}/mailbox/${mailboxId}`
  );
  return response.data;
};

const updateMailboxAccount = async (domain: string, mailboxId: number, accountData: {
  account: string;
  password: string | null;
  name: string;
  quota: number;
  active: boolean;
}) => {
  const response = await axios.post(
    `/api/services/hebergement/${domain}/mailbox/${mailboxId}`,
    accountData
  );
  return response.data;
};

const activateMailboxAccount = async (domain: string, mailboxId: number, active: boolean) => {
  const response = await axios.put(
    `/api/services/hebergement/${domain}/mailbox/${mailboxId}`,
    { active }
  );
  return response.data;
};

const createMailingList = async (domain: string, mailingListData: {
  account: string;
}) => {
  const response = await axios.post(
    `/api/services/hebergement/${domain}/mailbox/mailing-list`,
    mailingListData
  );
  return response.data;
};

const updateMailingList = async (domain: string, mailingListData: {
  oldAccountName: string;
  account: string;
}) => {
  const response = await axios.put(
    `/api/services/hebergement/${domain}/mailbox/mailing-list`,
    mailingListData
  );
  return response.data;
};

const getMailinglists = async (domain: string) => {
  const response = await axios.get(
    `/api/services/hebergement/${domain}/mailbox/mailing-list`
  );
  return response.data?.mailingList ?? response.data;
};

const deleteMailingList = async (domain: string, id: string) => {
  // const encodedId = encodeURIComponent(id);
  console.log("Deleting mailing list with id:", id);
  const response = await axios.delete(
    `/api/services/hebergement/${domain}/mailbox/mailing-list/${id}`
  );
  return response.data;
};

const createOrUpdateVacationMessage = async (
  domain: string,
  mailboxId: number,
  vacationData: {
    subject: string;
    body: string;
    active: boolean;
  }
) => {
  const response = await axios.put(
    `/api/services/hebergement/${domain}/mailbox/${mailboxId}/vacation-msg`,
    vacationData
  );
  return response.data;
};

const addAddressMailingList = async (
  domainName: string,
  data: { name: string; address: string, id?: string }
) => {
  const response = await axios.patch(
    `/api/services/hebergement/${domainName}/mailbox/mailing-list`,
    data
  );
  return response.data;
};



const deleteAddressMailingList = async (domain: string, mailingList: number, account: string) => {
  const response = await axios.delete(
    `/api/services/hebergement/${domain}/mailbox/mailing-list/${encodeURIComponent(mailingList)}/${encodeURIComponent(account)}`
  );
  return response.data;
};


export {
  getMailboxInfo,
  createMailboxAccount,
  createAlias,
  deleteAlias,
  getMailboxAccount,
  deleteMailboxAccount,
  updateMailboxAccount,
  activateMailboxAccount,
  createMailingList,
  updateMailingList,
  getMailinglists,
  deleteMailingList,
  createOrUpdateVacationMessage,
  addAddressMailingList,
  deleteAddressMailingList,
};
